/**
 * Shared UI utilities — one definition, used by every component that
 * needs avatar colors, initials, or contact masking.
 *
 * Extracted because these were duplicated across 6 files. The deletion
 * test: remove this module and the same hash + slice logic reappears
 * in every component that renders a player or team avatar.
 */

export const AVATAR_COLORS = ["amber", "teal", "violet", "magenta", "green", "azure"] as const;
export type AvatarColor = (typeof AVATAR_COLORS)[number];

export function avatarColor(name: string): AvatarColor {
  let h = 0;
  for (let i = 0; i < name.length; i++) h = (h * 31 + name.charCodeAt(i)) | 0;
  return AVATAR_COLORS[Math.abs(h) % AVATAR_COLORS.length]!;
}

export function initials(name: string): string {
  const parts = name.trim().split(/\s+/);
  if (parts.length === 0) return "?";
  if (parts.length === 1) return parts[0]![0]!.toUpperCase();
  return (parts[0]![0]! + parts[parts.length - 1]![0]!).toUpperCase();
}

export function maskPhone(phone: string): string {
  if (phone.length < 6) return phone;
  return phone.slice(0, 4) + "****" + phone.slice(-4);
}

export function firstName(name: string): string {
  return name.trim().split(/\s+/)[0] ?? name;
}
